export default __webpack_public_path__ + "static/media/01.96dfe6ae.jpeg";